// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AppointeeAppointment } from './appointee-appointment';
import { AppointmentType } from './appointment-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Appointment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  appointmentId!: number;
  address?: string;
  adminId!: number;
  adminTypeId!: number;
  appointmentTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  endDate?: Date;
  externalPracticeName?: string;
  isExternal!: boolean;
  isSignatory!: boolean;
  isSucceeding?: boolean;
  name?: string;
  notifyDate?: Date;
  number?: number;
  regNo?: string;
  startDate?: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  vacationDate?: Date;
  admin!: Admin;
  appointeeAppointments!: AppointeeAppointment[];
  appointmentType!: AppointmentType;
}

